import styled, { createGlobalStyle } from 'styled-components';
import theme from 'styles/theme';

const GlobalStyles = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css?family=Roboto+Condensed:400,500,700');
`;

/* Hub Wrapper */
const ElectionHub = styled.div`
  font-family: ${theme.fontAccent};

  /* -- -- - Has Groups -- -- - */
  &.election-hub--has-groups {
    flex-flow: column nowrap;
  }

  /* ----- Incumbent Key ----- */
  .election-hub-incumbent-key {
    background: #efefef;
    color: #545454;
    font-weight: 900;
    font-size: 0.85rem;
    line-height: 1;
    margin: 3.6875rem 0 4rem;
    padding: 0.95rem 1.75rem;

    .marker {
      height: 7px;
      width: 7px;
      background-color: #757575;
      border-radius: 50%;
      display: inline-block;
      line-height: 1;
      margin: 0.1875rem 12px 0.1875rem 0;
      vertical-align: top;
    }
  }

  /* ----- Larger-width Hub ----- */
  &.election-hub--max {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;

    .election-hub-widget-description,
    .election-hub-widget-title {
      flex: 0 0 100%;
    }

    .election-hub__card {
      margin-bottom: 1.875rem;
    }

    &.election-hub--has-groups {
      flex-flow: column nowrap;
    }

    &.election-hub--count-2 .election-hub__card {
      flex: 0 1 calc(50% - 1rem);
    }

    &.election-hub--count-3 .election-hub__card {
      flex: 0 1 calc(50% - 1rem);

      &:last-child {
        flex: 0 1 100%;
      }

      @media screen and (min-width: ${theme.lg}) {
        flex: 0 1 calc(33.33% - 1.3333125rem);

        &:last-child {
          flex: 0 1 calc(33.33% - 1.3333125rem);
        }
      }
    }

    &.election-hub--count-4 .election-hub__card {
      flex: 0 1 calc(50% - 1rem);

      @media screen and (min-width: ${theme.lg}) {
        flex: 0 1 calc(25% - 1.5rem);
      }
    }

    /* ----- Table ----- */
    .election-hub--race-card__candidates,
    .election-hub--measure-card__candidates {
      border-color: ${theme.black};
      border-style: solid;
      border-width: 2px 0;
      display: contents;
    }

    /* ----- Captions ----- */
    .election-hub__card--title {
      border-bottom: 0;
      padding-bottom: 0;
      padding-top: 0.625rem;

      span {
        margin-bottom: 0;
      }
    }

    /* ----- Subtitle/Description ----- */
    .election-hub--race-card__candidates .election-hub__card--sub-title,
    .election-hub__card--description {
      border-top: 1px solid ${theme.borderColor};
      padding-top: 0.625rem;
    }
  }
`;

/* Hub Title */
const ElectionHubTitle = styled.h2`
  font-family: ${theme.fontSourceSerifPro};
  font-size: 1.75em;
  font-weight: 700;
  line-height: 1.125;
  margin: 0 0 10px;
  text-align: left;
`;

/* Hub Description */
const ElectionHubDescription = styled.div`
  display: block;
  font-size: 1em;
  font-weight: 400;
  line-height: 1.125;
  margin-top: 10px;
  text-align: left;
`;

export default {
  GlobalStyles,
  ElectionHub,
  ElectionHubTitle,
  ElectionHubDescription,
};
